module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation4.63bb37b5.png";